module.exports = __webpack_public_path__ + "92030328142de9ba9766f2dd4fde42f0.png";